// extracted by mini-css-extract-plugin
export var copyright = "footer-module--copyright--90fb2";
export var foot = "footer-module--foot--c0cec";
export var hideElement = "footer-module--hide-element--422af";
export var social = "footer-module--social--f0e57";
export var subscribe = "footer-module--subscribe--b6f3a";
export var textMessages = "footer-module--text-messages--652da";